import defaultAccess from "@/modules/Employee/components/access"

export default {
    namespaced: true,
    state: {
        employee: {},
    },
    getters: {
        employee(state) {
            return state.employee;
        },
        currentEmployee(state) {
            return state.employee;
        },
        employeeAccess(state) {
            if (state.employee.metadata && state.employee.metadata.timeClockLogin && state.employee.metadata.timeClockLogin.access) {
                return state.employee.metadata.timeClockLogin.access
            } else {
                return {}
            }

        }
    },
    actions: {
        setEmployee({
            commit
        }, payload) {
            commit('setEmployee', payload);
        }
    },
    mutations: {
        setEmployee(state, payload) {
            // console.log('befre', payload.metadata.timeClockLogin.access)
            if (payload.metadata && payload.metadata.timeClockLogin && !payload.metadata.timeClockLogin.access) {
                console.log('you in there to and default access')
                payload.metadata.timeClockLogin.access = defaultAccess
            }

            if (payload.metadata && payload.metadata.timeClockLogin && payload.metadata.timeClockLogin.access) {
                payload.metadata.timeClockLogin.access = {
                    ...defaultAccess,
                    ...payload.metadata.timeClockLogin.access,
                }
            }

            state.employee = payload;

        }
    }
}